import { render, staticRenderFns } from "./NavigationBack.vue?vue&type=template&id=45663114&scoped=true&"
import script from "./NavigationBack.vue?vue&type=script&lang=js&"
export * from "./NavigationBack.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBack.vue?vue&type=style&index=0&id=45663114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45663114",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
